import React from 'react';
import { Edit, EyeOff, Eye } from 'lucide-react';
import { toast } from 'sonner';

const EditUserModal = ({ 
  isOpen, 
  onClose, 
  selectedUser, 
  getUserDisplayName,
  getStatusBadge,
  onActivate,
  onDeactivate,
  isActivating = false,
  isDeactivating = false
}) => {
  if (!isOpen || !selectedUser) return null;

  // Temporarily removed - Suspend User functionality not needed for now
  // const handleSuspend = () => {
  //   try {
  //     toast('Suspend functionality will be implemented soon', {
  //       icon: 'ℹ️',
  //       style: {
  //         background: '#fef3c7',
  //         color: '#92400e',
  //       },
  //     });
  //   } catch (error) {
  //     console.log('Suspend functionality will be implemented soon');
  //     alert('Suspend functionality will be implemented soon');
  //   }
  // };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <div className="flex items-center mb-4">
          <Edit className="h-6 w-6 text-primary-600 mr-3" />
          <h3 className="text-lg font-medium" style={{color: "#6b7280"}}>
            Edit User
          </h3>
        </div>
        <div className="mb-6">
          <p className="text-sm text-secondary-600 mb-4">
            Manage <strong>{getUserDisplayName(selectedUser)}</strong>
          </p>
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm font-medium text-dark-gray">Current Status:</span>
            {getStatusBadge(selectedUser)}
          </div>
        </div>
        
        <div className="space-y-3">
          {true && (
            <>
              {selectedUser.isActive ? (
                <button
                  onClick={() => onDeactivate(selectedUser._id)}

                  className="btn-secondary w-full"
                >
                  <EyeOff className="h-4 w-4 mr-2" />
                  Submit for Deactivation
                </button>
              ) : (
                <button
                  onClick={() => onActivate(selectedUser._id)}

                  className="w-full btn-secondary"
                >
                  <Eye className="h-4 w-4 mr-2" />
                  Submit for Activation
                </button>
              )}
            </>
          )}
          
          {/* Temporarily hidden - Suspend User functionality not needed for now
          <button
            onClick={handleSuspend}
            className="w-full flex items-center justify-center px-4 py-2 border border-yellow-300 rounded-md text-sm font-medium text-yellow-700 bg-yellow-50 hover:bg-yellow-100 transition-colors"
          >
            <Lock className="h-4 w-4 mr-2" />
            Suspend User
          </button>
          */}
        </div>

        <div className="flex justify-end space-x-3 mt-6">
          <button
            onClick={onClose}
            className="btn-primary"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditUserModal;